import { collection, doc } from 'firebase/firestore'

import { firestore } from '@/modules/auth/index-firebase'

abstract class AFirestore {
  private reference: string
  constructor(reference: string) {
    this.reference = reference
  }

  getCollection() {
    return collection(firestore, this.reference)
  }
  getDocument() {
    return doc(firestore, this.reference)
  }
}

export default AFirestore
